<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader media full>
      <TextHeading variant="subtitle" color="white-light">Morrisons News</TextHeading>
      <TextHeading variant="lg" color="white">Media Centre</TextHeading>
    </PageHeader>
    <PageCarousel class="media-centre__carousel"/>
    <PageGrid>
      <PageMain>
        <PageSection title="Latest News">
          <Cards>
            <CardsCol>
              <CardArticle
                title="We are proud of all our fresh fish and seafood sold in our stores and café."
                image="carrier-bags.jpg"
                date="01 Jan 2019"
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="Morrisons trials first plastic deposit return scheme in its supermarket."
                image="man-fish.jpg"
                date="12 Dec 2018"
              />
            </CardsCol>
            <CardsCol>
              <CardArticle
                title="Morrisons trials first plastic deposit return scheme in its supermarket."
                image="farmer.jpg"
                date="30 Aug 2018"
              />
            </CardsCol>
          </Cards>
        </PageSection>
        <PageSection title="Useful Links">
          <Cards>
            <CardsCol>
              <CardLink title="Board Members Biographies" category="Leadership"></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Learn more about our history and key milestones that goes over three lines"
                category="Company Info"
              ></CardLink>
            </CardsCol>
            <CardsCol>
              <CardLink
                title="Official photos, logos and assets for download"
                category="Media Assets"
              ></CardLink>
            </CardsCol>
          </Cards>
        </PageSection>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import CardsCol from '../elements/CardsCol.vue'
import TheFooter from '../components/TheFooter.vue'
import CardLink from '../components/CardLink.vue'
import Cards from '../elements/Cards.vue'
import CardArticle from '../components/CardArticle.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import PageGrid from '../elements/PageGrid.vue'
import PageCarousel from '../components/PageCarousel.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'PageMediaCenter',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    PageCarousel,
    PageGrid,
    PageMain,
    PageSection,
    Cards,
    CardArticle,
    CardLink,
    TheFooter,
    CardsCol
  },
  props: {
    linkHref: {
      type: String,
      default: null
    }
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>
<style lang="postcss">
</style>